module.exports = __webpack_public_path__ + "media/images/ui__warning--dark-82da922e9f21c3eb59c33d36d5038fba.png";